import React, { useEffect, useMemo, useState } from 'react';
import { useInView } from 'react-intersection-observer';


export const DynamicBlock = ({
    child,
    children,
    direction = 'up', // 'up' | 'down' | 'left' | 'right'
    infinite = true, //  постоянная анимация
    distance = 40, // стартовое смещение для появления
    durationMs = 700, // длительность появления
    delayMs = 200, // задержка появления
    className,
})=>{

    const { ref, inView } = useInView({
        triggerOnce: !infinite,
        threshold: 0.3,
    });

    const [isShown, setIsShown] = useState(false);

    useEffect(() => {
        if (inView) {
            setTimeout(() => setIsShown(true), delayMs);
        } else if (infinite) {
            setIsShown(false);
        }
    }, [inView, infinite, delayMs]);

    const initialTransform = useMemo(() => {
        switch (direction) {
            case 'down': return `translate3d(0, -${distance}px, 0)`;
            case 'left': return `translate3d(${distance}px, 0, 0)`;
            case 'right': return `translate3d(-${distance}px, 0, 0)`;
            case 'up':
            default: return `translate3d(0, ${distance}px, 0)`;
        }
    }, [direction, distance]);

    const content = child ?? children ?? null;

    const baseStyle = {
        transition: `transform ${durationMs}ms ease, opacity ${durationMs}ms ease`,
        willChange: 'transform, opacity',
        opacity: isShown ? 1 : 0,
        transform: isShown ? 'translate3d(0,0,0)' : initialTransform,
    };

    return (
        <div ref={ref} className={className} style={baseStyle}>
            {content}
        </div>
    );
}